var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-customer-of-system',{ref:"table",staticClass:"pt-customer-of-system__withData",attrs:{"rolesList":_vm.rolesList},on:{"deleteCustomer":_vm.deleteCustomer}})}
var staticRenderFns = []

export { render, staticRenderFns }